import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, firstValueFrom, Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { TermsText } from "./contact-info.service";
import { SessionContext } from "../models/session-context.model";
import { ModalService } from "./modal.service";
import { AcknowledgmentDetailsList } from "../models/authentication-result.model";

@Injectable({
  providedIn: "root",
})

export class BeforeLoginService {
  fetchInstitutionsUrl: string =
    environment.backend.baseUrl +
    environment.backend.contextPath +
    "/rest/get-institutions/";

  fetchTermsUrl: string =
    environment.backend.baseUrl +
    environment.backend.contextPath +
    "/rest/get-tos/";

  fetchedInstitutions = new Subject<Institution[]>();
  termsOfService = new Subject<string>();
  isPrescriptionTosEnabled: boolean = true;
  sessionContext: SessionContext;

  private institutionsSubject: BehaviorSubject<Institution[]> = new BehaviorSubject<Institution[]>([]);

  constructor(
    private http: HttpClient,
  ) {}

  fetchInstitutions(): void {
    this.http.get<Institution[]>(this.fetchInstitutionsUrl, {
      observe: "response",
      withCredentials: true,
    }).subscribe(
      response => this.institutionsSubject.next(response.body),
      error => {
        console.error("Error fetching institutions:", error);
        this.institutionsSubject.next([]);
      },
    );
  }

  getInstitutions(): Observable<Institution[]> {
    return this.institutionsSubject.asObservable();
  }

  getFetchedInstitutions(): Observable<Institution[]> {
    return this.fetchedInstitutions.asObservable();
  }

  fetchTerms(currentLang: string, termsContentType: string) {
    return this.http
      .get<TermsText>(this.fetchTermsUrl, {
        observe: "response",
        withCredentials: true,
        params: { lang: currentLang, termsContentType: termsContentType },
      })
      .toPromise();
    /* .then((response) => {
        this.termsOfService.next(response.body.text);
      })
      .catch((err) => console.log("Error: ", err));*/
  }

  /* getTermsOfService(): Observable<string> {
    return this.termsOfService.asObservable();
  }*/
}

export interface Institution {
  id: number;
  name: string;
}

